import React from 'react';

const CaseInProgress = props => (
    <section className="work__progress">
        <div className="row">
            <div className="col-xs-12 col-sm-6 no-padding-left">
                <div className="work__case">
                    <h3 className="work__case--subtitle">Police Rijnmond</h3>
                    <h2 className="work__case--title">
                        Giving potential drugdealers a better deal with a
                        fashion brand
                    </h2>
                    <p className="work__case--status">In progress</p>
                </div>
            </div>
            <div className="col-xs-12 col-sm-6 no-padding-right">
                <div className="work__case">
                    <h3 className="work__case--subtitle">District East</h3>
                    <h2 className="work__case--title">
                        Uniting entrepreneurs to stand their ground in urban
                        development
                    </h2>
                    <p className="work__case--status">In progress</p>
                </div>
            </div>
        </div>
    </section>
);

export default CaseInProgress;



// WEBPACK FOOTER //
// ./src/components/Pages/WorkOverview/CaseInProgress.jsx